{
  "removeButtonLabel": "הסר",
  "removeDescription": "לחץ על מחק כדי להסיר תג."
}
